import { Pipe, PipeTransform } from '@angular/core';
import { PhotoDto } from '../../../../models/trofaco/photoDto';
import { PhotoCollectionDto } from '../../../../models/trofaco/photoCollectionDto';

@Pipe({
  name: 'isCollectionThumbnail'
})
export class IsCollectionThumbnailPipe implements PipeTransform {

  transform(photo: PhotoDto, collection: PhotoCollectionDto): boolean {
    return photo.id == collection.thumbnailPhotoId;
  }

}
